import { Head, Link, router } from "@inertiajs/react"
import { ArrowRight } from "lucide-react"
import { type ReactNode, useCallback, useRef, useState } from "react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { signInPath, signUpPath } from "@/routes"

// ─── Brand SVG Icons (converted from legacy React Native) ─────────────

function IconProfile({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 54 54" fill="currentColor">
      <path d="M45.29,27.01c0-10.08-8.2-18.29-18.29-18.29S8.71,16.92,8.71,27.01c0,5.53,2.49,10.5,6.38,13.85c0.01,0.01,0.02,0.02,0.03,0.03c3.2,2.74,7.34,4.4,11.86,4.4c4.48,0,8.59-1.63,11.78-4.32c0.04-0.04,0.09-0.07,0.13-0.12C42.8,37.5,45.29,32.54,45.29,27.01z M10.28,27.01c0-9.22,7.5-16.72,16.72-16.72s16.72,7.5,16.72,16.72c0,4.81-2.05,9.12-5.3,12.18c-2.45-3.53-6.72-5.69-11.4-5.69c-4.69,0-8.96,2.17-11.4,5.7C12.34,36.15,10.28,31.81,10.28,27.01z M16.79,40.22c2.14-3.18,5.97-5.15,10.21-5.15s8.05,1.96,10.21,5.15c-2.82,2.18-6.36,3.51-10.21,3.51S19.63,42.4,16.79,40.22z" />
      <path d="M24.99,30.63c0.66,0.19,1.34,0.28,2.02,0.28c1.24,0,2.47-0.31,3.58-0.93c1.71-0.96,2.95-2.53,3.49-4.42s0.3-3.87-0.65-5.6c-0.96-1.71-2.53-2.95-4.42-3.49c-1.89-0.54-3.87-0.3-5.6,0.65c-1.71,0.96-2.95,2.53-3.49,4.42s-0.3,3.87,0.65,5.6C21.54,28.86,23.1,30.1,24.99,30.63z M21.43,21.99c0.42-1.49,1.4-2.72,2.74-3.48c0.87-0.48,1.84-0.74,2.81-0.74c0.53,0,1.06,0.07,1.59,0.22c1.49,0.42,2.72,1.4,3.48,2.74s0.93,2.91,0.51,4.4c-0.42,1.49-1.4,2.72-2.74,3.48c-1.34,0.76-2.91,0.93-4.4,0.51c-1.49-0.42-2.72-1.4-3.48-2.74C21.2,25.03,21.02,23.47,21.43,21.99z" />
    </svg>
  )
}

function IconPros({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 54 54" fill="currentColor">
      <path d="M13.63,13.77c0.08,0.08,0.12,0.2,0.11,0.31l-0.35,2.25c-0.05,0.29,0.26,0.51,0.52,0.37l2-1.07c0.1-0.06,0.23-0.06,0.33,0l2.03,1.03c0.26,0.13,0.57-0.09,0.52-0.38l-0.4-2.24c-0.02-0.12,0.02-0.23,0.1-0.32l1.61-1.61c0.21-0.21,0.09-0.57-0.21-0.61l-2.25-0.31c-0.12-0.02-0.22-0.09-0.27-0.19l-1.04-2.02c-0.13-0.26-0.51-0.26-0.64,0.01l-0.99,2.05c-0.05,0.11-0.15,0.18-0.27,0.2l-2.25,0.36c-0.29,0.05-0.41,0.41-0.19,0.61L13.63,13.77z" />
      <path d="M35.56,13.77c0.08,0.08,0.12,0.2,0.11,0.31l-0.35,2.25c-0.05,0.29,0.26,0.51,0.52,0.37l2-1.07c0.1-0.06,0.23-0.06,0.33,0l2.03,1.03c0.26,0.13,0.57-0.09,0.52-0.38l-0.4-2.24c-0.02-0.12,0.02-0.23,0.1-0.32l1.61-1.61c0.21-0.21,0.09-0.57-0.21-0.61l-2.25-0.31c-0.12-0.02-0.22-0.09-0.27-0.19l-1.04-2.02c-0.13-0.26-0.51-0.26-0.64,0.01l-0.99,2.05c-0.05,0.11-0.15,0.18-0.27,0.2l-2.25,0.36c-0.29,0.05-0.41,0.41-0.19,0.61L35.56,13.77z" />
      <path d="M24.59,8.79c0.08,0.08,0.12,0.2,0.11,0.31l-0.35,2.25c-0.05,0.29,0.26,0.51,0.52,0.37l2-1.07c0.1-0.06,0.23-0.06,0.33,0l2.03,1.03c0.26,0.13,0.57-0.09,0.52-0.38l-0.4-2.24c-0.02-0.12,0.02-0.23,0.1-0.32l1.61-1.61c0.21-0.21,0.09-0.57-0.21-0.61l-2.25-0.31c-0.12-0.02-0.22-0.09-0.27-0.19l-1.04-2.02c-0.13-0.26-0.51-0.26-0.64,0.01l-0.99,2.05c-0.05,0.11-0.15,0.18-0.27,0.2L23.14,6.6c-0.29,0.05-0.41,0.41-0.19,0.61L24.59,8.79z" />
      <path d="M43.19,34.02c0-8.93-7.26-16.19-16.19-16.19s-16.19,7.26-16.19,16.19c0,8.92,7.26,16.19,16.19,16.19c4.01,0,7.68-1.47,10.51-3.9c0.01-0.02,0.03-0.02,0.04-0.04C40.99,43.29,43.19,38.91,43.19,34.02z M12.41,34.02c0-8.04,6.54-14.59,14.59-14.59s14.59,6.54,14.59,14.59c0,4.15-1.75,7.89-4.54,10.55c-2.19-3.07-5.93-4.95-10.05-4.95c-4.11,0-7.86,1.88-10.05,4.95C14.16,41.91,12.41,38.17,12.41,34.02z M18.18,45.61c1.87-2.72,5.18-4.39,8.82-4.39c3.65,0,6.95,1.68,8.82,4.39c-2.45,1.87-5.51,3-8.82,3S20.63,47.48,18.18,45.61z" />
      <path d="M25.21,37.31c0.59,0.17,1.2,0.25,1.8,0.25c1.11,0,2.2-0.28,3.2-0.84c1.53-0.86,2.64-2.26,3.12-3.95c0.48-1.69,0.27-3.46-0.58-5c-0.86-1.53-2.26-2.64-3.95-3.12c-1.69-0.48-3.46-0.27-5,0.58c-1.53,0.86-2.64,2.26-3.12,3.95C19.69,32.68,21.72,36.32,25.21,37.31z M22.21,29.63c0.36-1.28,1.2-2.34,2.36-2.99c0.75-0.42,1.58-0.63,2.42-0.63c0.46,0,0.91,0.06,1.36,0.19c1.28,0.36,2.34,1.2,2.99,2.36c0.65,1.16,0.81,2.5,0.44,3.78c-0.36,1.28-1.2,2.34-2.36,2.99c-1.16,0.65-2.5,0.8-3.78,0.44C23,35.02,21.47,32.27,22.21,29.63z" />
    </svg>
  )
}

function IconInsti({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 54 54" fill="currentColor">
      <path d="M13.67,13.59c0.08,0.08,0.12,0.2,0.11,0.31l-0.35,2.25c-0.05,0.29,0.26,0.51,0.52,0.37l2-1.07c0.1-0.06,0.23-0.06,0.33,0l2.03,1.03c0.26,0.13,0.57-0.09,0.52-0.38l-0.4-2.24c-0.02-0.12,0.02-0.23,0.1-0.32l1.61-1.61c0.21-0.21,0.09-0.57-0.21-0.61L17.67,11c-0.12-0.02-0.22-0.09-0.27-0.19l-1.04-2.02c-0.13-0.26-0.51-0.26-0.64,0.01l-0.99,2.05c-0.05,0.11-0.15,0.18-0.27,0.2l-2.25,0.36c-0.29,0.05-0.41,0.41-0.19,0.61L13.67,13.59z" />
      <path d="M35.6,13.59c0.08,0.08,0.12,0.2,0.11,0.31l-0.35,2.25c-0.05,0.29,0.26,0.51,0.52,0.37l2-1.07c0.1-0.06,0.23-0.06,0.33,0l2.03,1.03c0.26,0.13,0.57-0.09,0.52-0.38l-0.4-2.24c-0.02-0.12,0.02-0.23,0.1-0.32l1.61-1.61c0.21-0.21,0.09-0.57-0.21-0.61L39.6,11c-0.12-0.02-0.22-0.09-0.27-0.19l-1.04-2.02c-0.13-0.26-0.51-0.26-0.64,0.01l-0.99,2.05c-0.05,0.11-0.15,0.18-0.27,0.2l-2.25,0.36c-0.29,0.05-0.41,0.41-0.19,0.61L35.6,13.59z" />
      <path d="M24.63,8.6c0.08,0.08,0.12,0.2,0.11,0.31l-0.35,2.25c-0.05,0.29,0.26,0.51,0.52,0.37l2-1.07c0.1-0.06,0.23-0.06,0.33,0l2.03,1.03c0.26,0.13,0.57-0.09,0.52-0.38l-0.4-2.24c-0.02-0.12,0.02-0.23,0.1-0.32l1.61-1.61c0.21-0.21,0.09-0.57-0.21-0.61l-2.25-0.31C28.52,6,28.42,5.93,28.36,5.83L27.33,3.8c-0.13-0.26-0.51-0.26-0.64,0.01L25.7,5.86c-0.05,0.11-0.15,0.18-0.27,0.2l-2.25,0.36c-0.29,0.05-0.41,0.41-0.19,0.61L24.63,8.6z" />
      <path d="M42.53,23.31c-0.03-0.42-0.38-0.75-0.8-0.75c-9.76,0-13.84-6.17-14.02-6.44c-0.14-0.22-0.37-0.34-0.62-0.35c-0.02,0-0.05,0-0.07,0c-0.05,0-0.09-0.01-0.14,0c-0.24,0.02-0.47,0.13-0.61,0.35c-0.17,0.26-4.25,6.44-14.02,6.44c-0.42,0-0.77,0.33-0.8,0.75c-0.01,0.19-1.03,18.74,15.12,26.99c0.07,0.04,0.15,0.04,0.22,0.05c0.01,0,0.02,0,0.03,0.01c0.04,0.01,0.07,0.03,0.11,0.03c0.01,0,0.03-0.01,0.04-0.01c0.01,0,0.03,0.01,0.04,0.01c0.04,0,0.07-0.02,0.11-0.03c0.01,0,0.02,0,0.03-0.01c0.07-0.01,0.15-0.02,0.22-0.05C43.56,42.05,42.54,23.5,42.53,23.31z M27,48.7c-13.1-6.92-13.94-21.16-13.95-24.55c8.08-0.26,12.43-4.48,13.95-6.32c1.52,1.84,5.87,6.06,13.95,6.32C40.94,27.55,40.1,41.78,27,48.7z" />
      <path d="M20.89,33.59c-0.39-0.39-1.03-0.38-1.41,0.01s-0.38,1.03,0.01,1.41l4.54,4.48c0.19,0.18,0.44,0.29,0.7,0.29c0,0,0.01,0,0.01,0c0.27,0,0.52-0.11,0.71-0.3l9.17-9.42c0.38-0.4,0.38-1.03-0.02-1.41c-0.4-0.38-1.03-0.38-1.41,0.02l-8.46,8.7L20.89,33.59z" />
    </svg>
  )
}

function IconKrowned({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 54 54">
      <defs>
        <linearGradient
          id="gk1"
          x1="30.63"
          y1="3.84"
          x2="24.53"
          y2="33.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFB01C" />
          <stop offset="1" stopColor="#F58610" />
        </linearGradient>
        <linearGradient
          id="gk2"
          x1="27.62"
          y1="3.64"
          x2="21.24"
          y2="34.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFB01C" />
          <stop offset="1" stopColor="#F58610" />
        </linearGradient>
      </defs>
      <path
        fill="url(#gk1)"
        d="M15.54,31.44l-4.12-9.8c-0.27-0.65,0.38-1.3,1.03-1.02l8.31,3.58l5.64-11.66c0.29-0.59,1.14-0.59,1.42,0.01l5.7,12.28l8.05-4.31c0.64-0.34,1.36,0.29,1.1,0.97L39,31.2c-0.31,0.81-1.08,1.35-1.95,1.36l-19.56,0.17C16.64,32.73,15.87,32.22,15.54,31.44z"
      />
      <path
        fill="#FF9119"
        d="M36.62,39.44H17.57c-0.89,0-1.61-0.72-1.61-1.61s0.72-1.61,1.61-1.61h19.05C38.73,36.24,38.75,39.4,36.62,39.44z"
      />
      <path
        fill="url(#gk2)"
        d="M27.08,3.26c-3.96,0.1-3.96,5.91,0,6.01C31.04,9.17,31.04,3.36,27.08,3.26z"
      />
    </svg>
  )
}

// ─── Screen Data ──────────────────────────────────────────────────────

interface Screen {
  icon: (props: { className?: string }) => ReactNode
  title: string
  description: string
  glowColor: string
  iconBgClass: string
}

const SCREENS: Screen[] = [
  {
    icon: ({ className }) => (
      <img src="/images/krown_icon.png" alt="" className={className} />
    ),
    title: "Bienvenido a KrownFT",
    description:
      "La plataforma donde el talento del fútbol se encuentra con la oportunidad.",
    glowColor: "bg-krown-crown",
    iconBgClass: "",
  },
  {
    icon: ({ className }) => <IconProfile className={className} />,
    title: "Creá tu perfil profesional",
    description:
      "Armá tu perfil con tus stats, highlights y videos. Mostrá todo lo que sabés hacer en la cancha.",
    glowColor: "bg-krown-200",
    iconBgClass: "bg-krown-200/10 border border-krown-200/20",
  },
  {
    icon: ({ className }) => <IconPros className={className} />,
    title: "Conectá con scouts y clubes",
    description:
      "Scouts y clubes buscan jugadores como vos todos los días. Hacete visible.",
    glowColor: "bg-krown-accent",
    iconBgClass: "bg-krown-accent/10 border border-krown-accent/20",
  },
  {
    icon: ({ className }) => <IconInsti className={className} />,
    title: "Oportunidades reales",
    description:
      "Accedé a pruebas, convocatorias y ofertas de clubes verificados. Tu próxima oportunidad está acá.",
    glowColor: "bg-krown-crown",
    iconBgClass: "bg-krown-crown/10 border border-krown-crown/20",
  },
  {
    icon: ({ className }) => <IconKrowned className={className} />,
    title: "Empezá ahora",
    description:
      "Unite a miles de jugadores que ya están conectando con el fútbol profesional.",
    glowColor: "bg-krown-orange-from",
    iconBgClass: "",
  },
]

const ICON_COLORS: Record<number, string> = {
  1: "text-krown-100",
  2: "text-krown-accent",
  3: "text-krown-crown",
}

const STORAGE_KEY = "mobile_onboarding_completed"

// ─── Component ────────────────────────────────────────────────────────

export default function MobileOnboarding() {
  const [completed] = useState(() => {
    if (typeof window === "undefined") return true
    return localStorage.getItem(STORAGE_KEY) === "true"
  })

  const [currentScreen, setCurrentScreen] = useState(0)
  const [direction, setDirection] = useState<"left" | "right">("left")
  const [isAnimating, setIsAnimating] = useState(false)
  const touchStartX = useRef(0)
  const touchStartY = useRef(0)

  const isLastScreen = currentScreen === SCREENS.length - 1

  const goTo = useCallback(
    (index: number) => {
      if (isAnimating || index === currentScreen) return
      if (index < 0 || index >= SCREENS.length) return
      setDirection(index > currentScreen ? "left" : "right")
      setIsAnimating(true)
      setCurrentScreen(index)
      setTimeout(() => setIsAnimating(false), 350)
    },
    [currentScreen, isAnimating],
  )

  const handleNext = useCallback(() => {
    goTo(currentScreen + 1)
  }, [currentScreen, goTo])

  const handleComplete = useCallback((path: string) => {
    localStorage.setItem(STORAGE_KEY, "true")
    router.visit(path)
  }, [])

  const handleSkip = useCallback(() => {
    handleComplete(signUpPath())
  }, [handleComplete])

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX
    touchStartY.current = e.touches[0].clientY
  }, [])

  const handleTouchEnd = useCallback(
    (e: React.TouchEvent) => {
      const deltaX = e.changedTouches[0].clientX - touchStartX.current
      const deltaY = e.changedTouches[0].clientY - touchStartY.current
      if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0 && currentScreen < SCREENS.length - 1) {
          goTo(currentScreen + 1)
        } else if (deltaX > 0 && currentScreen > 0) {
          goTo(currentScreen - 1)
        }
      }
    },
    [currentScreen, goTo],
  )

  // If already completed, show minimal mobile landing
  if (completed) {
    return (
      <div
        className="bg-background flex min-h-svh flex-col items-center justify-center gap-8 px-6"
        style={{
          paddingTop: "env(safe-area-inset-top, 0px)",
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
        }}
      >
        <img
          src="/images/krown_logo_header.png"
          alt="KrownFT"
          className="h-10"
        />
        <div className="flex w-full max-w-xs flex-col gap-3">
          <Button variant="cta" size="lg" className="w-full" asChild>
            <Link href={signUpPath()}>Crear cuenta</Link>
          </Button>
          <Button
            variant="ghost"
            size="lg"
            className="text-muted-foreground w-full"
            asChild
          >
            <Link href={signInPath()}>Ya tengo cuenta</Link>
          </Button>
        </div>
      </div>
    )
  }

  const screen = SCREENS[currentScreen]
  const isImageScreen = currentScreen === 0 || currentScreen === 4

  return (
    <>
      <Head title="KrownFT" />

      <div
        className="bg-background flex min-h-svh flex-col overflow-hidden"
        style={{
          paddingTop: "env(safe-area-inset-top, 0px)",
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
        }}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {/* ── Top bar: logo + skip ─────────────────── */}
        <div className="flex items-center justify-between px-6 pt-4 pb-2">
          <img
            src="/images/krown_logo_header.png"
            alt="KrownFT"
            className="h-7 opacity-70"
          />
          {!isLastScreen && (
            <button
              onClick={handleSkip}
              className="text-muted-foreground text-sm font-medium tracking-wide transition-colors active:text-white"
            >
              Omitir
            </button>
          )}
        </div>

        {/* ── Screen content ───────────────────────── */}
        <div className="relative flex flex-1 flex-col items-center justify-center px-8">
          {/* Ambient glow */}
          <div className="pointer-events-none absolute inset-0">
            <div
              className={cn(
                "absolute top-1/3 left-1/2 h-[320px] w-[320px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-[0.10] blur-[100px] transition-all duration-500",
                screen.glowColor,
              )}
            />
            <div
              className={cn(
                "absolute bottom-1/4 left-1/4 h-[200px] w-[200px] rounded-full opacity-[0.05] blur-[80px] transition-all duration-500",
                screen.glowColor,
              )}
            />
          </div>

          {/* Animated screen */}
          <div
            key={currentScreen}
            className={cn(
              "relative flex flex-col items-center text-center",
              direction === "left"
                ? "animate-[slideInLeft_350ms_ease-out_forwards]"
                : "animate-[slideInRight_350ms_ease-out_forwards]",
            )}
            style={{
              animationName:
                direction === "left" ? "slideInLeft" : "slideInRight",
            }}
          >
            {/* Icon */}
            {isImageScreen ? (
              screen.icon({ className: "mb-8 h-28 w-28 object-contain" })
            ) : (
              <div
                className={cn(
                  "mb-8 flex h-24 w-24 items-center justify-center rounded-2xl",
                  screen.iconBgClass,
                )}
              >
                {screen.icon({
                  className: cn("h-12 w-12", ICON_COLORS[currentScreen]),
                })}
              </div>
            )}

            {/* Title */}
            <h1 className="mb-4 text-[26px] leading-tight font-bold tracking-wide text-white">
              {screen.title}
            </h1>

            {/* Description */}
            <p className="text-muted-foreground max-w-[300px] text-base leading-relaxed">
              {screen.description}
            </p>
          </div>
        </div>

        {/* ── Bottom controls ──────────────────────── */}
        <div className="flex flex-col items-center gap-6 px-8 pb-8">
          {/* Dot indicators */}
          <div
            className="flex items-center justify-center gap-2"
            role="tablist"
          >
            {SCREENS.map((_, i) => (
              <button
                key={i}
                role="tab"
                aria-selected={i === currentScreen}
                aria-label={`Pantalla ${i + 1}`}
                onClick={() => goTo(i)}
                className={cn(
                  "h-2 rounded-full transition-all duration-300",
                  i === currentScreen
                    ? "bg-krown-accent w-7"
                    : "bg-krown-grey-65 w-2",
                )}
              />
            ))}
          </div>

          {/* Action buttons */}
          {isLastScreen ? (
            <div className="flex w-full max-w-xs flex-col gap-3">
              <Button
                variant="cta"
                size="lg"
                className="group w-full gap-2 text-base"
                onClick={() => handleComplete(signUpPath())}
              >
                Crear cuenta
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
              <Button
                variant="ghost"
                size="lg"
                className="text-muted-foreground w-full"
                onClick={() => handleComplete(signInPath())}
              >
                Ya tengo cuenta
              </Button>
            </div>
          ) : (
            <Button
              variant="brand-outline"
              size="lg"
              className="w-full max-w-xs gap-2 text-base"
              onClick={handleNext}
            >
              Siguiente
              <ArrowRight className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>

      <style>{`
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(60px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(-60px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </>
  )
}
